module.exports = "<mat-list-item>\r\n  <mat-icon mat-list-avatar>{{feature.icon}}</mat-icon>\r\n  <h4 matLine *ngIf=\"feature.title_html\" [innerHtml]=\"feature.title_html\"></h4>\r\n  <h4 matLine *ngIf=\"!feature.title_html\">{{title}}</h4>\r\n</mat-list-item>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/feature/feature-item/feature-item.component.html
// module id = 945
// module chunks = 0